import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import MobileService from '../components/MobileService';
import Therapist from '../components/Therapist';
import Booking from '../components/Booking';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';

const Home = () => {
  useSeo('Aura Lune RMT | Registered Massage Therapist Mississauga', 'Aura Lune RMT — Registered Massage Therapist in Mississauga (Streetsville). Swedish, lymphatic drainage, prenatal and mobile massage. Insurance receipts. Book online.');
  const scrollToBooking = () => {
    document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="bg-[#F4EFE7] min-h-screen">
      <Navbar />
      <Hero />
      <Services onBook={scrollToBooking} />
      <MobileService />
      <Therapist />
      <Booking />
      <Footer />
    </div>
  );
};

export default Home;
